import { signalSourceSchema } from "@healthos/shared";
import { z } from "zod";
export const InjectSignalRequest = z.object({
    userId: z.string(),
    kind: z.string(),
    payload: z.record(z.string(), z.unknown()).default({}),
    source: signalSourceSchema.default("simulation"),
    tick: z.boolean().default(true),
});
export const InjectSignalResponse = z.object({
    status: z.literal("ok"),
    outcome: z.record(z.string(), z.unknown()).nullable(),
});
export const ForceTickRequest = z.object({
    userId: z.string(),
    reason: z.string().default("simulation"),
    /**
     * Run the tick as an operator: ignore the attention cooldown and the quiet
     * gates that hold a surface back on an ordinary day.
     *
     * The pipeline has always taken these, and nothing could pass them, so the
     * only way to see a card appear from the demo panel was the story endpoint,
     * which writes the decision itself and never runs the pipeline. A forced tick
     * inside the 120-minute cooldown could only ever come back quiet, which is
     * exactly when someone is trying to watch a decision happen.
     */
    force: z.boolean().default(false),
});
/**
 * Ask a member's connected devices for their history again.
 *
 * A connection outliving its signals is not hypothetical: a reset wipes signals
 * and leaves the connection, a missed webhook window loses a night, and the
 * backfill only ever ran once at connect time. Without this the ring stays
 * connected and permanently silent.
 */
export const ReplayConnectionsRequest = z.object({
    userId: z.string(),
});
export const ReplayConnectionsResponse = z.object({
    status: z.literal("ok"),
    requested: z.array(z.string()),
});
export const ForceTickResponse = z.object({
    status: z.literal("ok"),
    outcome: z.record(z.string(), z.unknown()).nullable(),
});
export const ForceBriefRequest = z.object({
    userId: z.string(),
    timezone: z.string().default("UTC"),
    isWelcome: z.boolean().optional(),
    firstName: z.string().nullable().optional(),
});
export const ForceBriefResponse = z.union([
    z.object({ status: z.literal("ok"), briefId: z.string() }),
    z.object({ status: z.literal("exists"), message: z.string() }),
]);
export const SimulationProxyResponse = z.record(z.string(), z.unknown());
/**
 * Bootstrap a heartbeat_user_state row for a user. Idempotent (existing
 * row left intact). This is a dev-only simulation helper; production
 * onboarding writes the row directly in core-api.
 *
 * Cohort is assigned deterministically by shared FNV-1a hash of userId
 * mod 100, default 10% control. Sticky for life of user.
 */
export const BootstrapHeartbeatStateRequest = z.object({
    userId: z.string(),
});
export const BootstrapHeartbeatStateResponse = z.object({
    status: z.literal("ok"),
    cohort: z.enum(["treatment", "control"]),
    bootstrapped: z.boolean(),
});
//# sourceMappingURL=simulation.js.map